import CustomUserChip from '../../../../../components/CustomUserChip';
import { CloseIcon, InfoChip } from '../../../../../components/buttons/IconButtons';
import { POSITION_MODEL } from '../../../../../Helpers/PositionModel';
import React from 'react';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 *
 * @param t
 * @param className: String for className
 * @param foodieSetting: data by configuration setting
 * @param setShowBanner: event to set data
 */
const BannerInfo = ({ t, className = 'col-12 mb-3', foodieSetting, setShowBanner }) => {
    const badgeBaseCost = foodieSetting?.isBaseCost ? t("this_order_is_charged_as_a_complete_set_all_courses_included")
        : t("this_order_is_billed_by_course_selection");
    const badgeText = foodieSetting?.isMealTimeCost ? t("this_order_is_charged_by_meal_time") : badgeBaseCost;

    return (
        <div className={className}>
            <CustomUserChip
                className="m-0 chip-secondary-150-100 w-100 p-0 justify-content-start"
                name={badgeText}
                Icon={InfoChip}
                showAvatar={true}
                variant="large"
                iconPosition={POSITION_MODEL.LEFT}
                onDelete={() => {
                    if (setShowBanner)
                        setShowBanner(false);
                }}
                classNameIcon="icon-color-secondary-700"
                deleteIcon={<CloseIcon className={`icon-color-secondary-700 h-18px`} />}
            />
        </div>
    )

}

export default BannerInfo
